import { render, staticRenderFns } from "./SupervisedSummary.vue?vue&type=template&id=3d08bdbe&scoped=true&"
import script from "./SupervisedSummary.vue?vue&type=script&lang=js&"
export * from "./SupervisedSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08bdbe",
  null
  
)

export default component.exports